import withType from 'components/common/hoc/withType'
import BOTCareersPageBanner from './BOTCareersPageBanner'

export default withType({ type: 'BOTCareersPageBanner' })(BOTCareersPageBanner)
